import { ChangeDetectorRef, Injectable } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BaseService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-service.component";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { take, takeUntil } from "rxjs/operators";
import { SimpleModalService } from "../../../../../projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { CustomerFormComponent } from "../../parties/customer/customer-form.component";
import { CustomerAddress, CustomerDetailInfoViewModel } from "../../parties/model/customer.model";
import { ActivePageEnum } from "../model/activepage.enum";
import { CustomerDetailsEnum } from "../model/customerdetailenum";
import { OrderService } from "../order.service";
import { AddressPhoneFormComponent } from "../orderpage/fastaccess/address-phone-form/address-phone-form.component";
import { BehaviorSubject, Subject } from "rxjs";
import { DiscountTypeEnum } from "../model/invoice.model";
import { CustomerCategory } from "../../parties/model/customer-categories.model";

export type CustomerLoadModel = {
  type: "NotLoaded" | "Pending" | "Loaded";
  customerId?: number;
};

@Injectable({
  providedIn: "root",
})
export class CustomerOrderService extends BaseService {
  CallerIdNumber: string;
  currentCustomer: CustomerDetailInfoViewModel;
  customerDetailsEnum: typeof CustomerDetailsEnum = CustomerDetailsEnum;
  currentCustomerDetailsEnum: CustomerDetailsEnum = CustomerDetailsEnum.Details;
  isEditing: boolean;
  _showNewCustomerForm;
  // currentSaleMethodBranch: SaleMethodBranchModel;
  areaName: string;
  debitTitle: string = this.translate("ClientApp.FrontOffice.Order.CustomerOrder.TotalDebit");
  group: FormGroup;
  cd: ChangeDetectorRef;
  customerDetailsIsLoaded$ = new BehaviorSubject<CustomerLoadModel>({ type: "NotLoaded" });
  doubleClickUnsubscribe$ = new Subject<void>();

  constructor(public order: OrderService, public dialog: SimpleModalService, public common: CommonService) {
    super();
    let groupmodel: any = {};
    groupmodel["Numbers"] = new FormControl(undefined, Validators.maxLength(200));
    this.group = new FormGroup(groupmodel);
    this.CallerIdNumber = "";
  }
  //دریافت اطلاعات مشتری انتخاب شده در جدول به همراه جزئیات مربوطه
  GetCustomerDetails(id, loadCostomerInfo?: boolean, CallerIdNumber?: string) {
    this.customerDetailsIsLoaded$.next({ type: "Pending" });
    if (id) {
      this._showNewCustomerForm = false;
      this.httpCommonService
        .getItem("Customer/GetCustomerDetails", id)
        .pipe(take(1), takeUntil(this.doubleClickUnsubscribe$))
        .subscribe(
          async (customer: CustomerDetailInfoViewModel) => {
            customer.Addresses = customer.Addresses.sort((a, b) => a.Order - b.Order);
            customer.Numbers = customer.Numbers.sort((a, b) => a.Order - b.Order);
            let phoneNumber = customer.Numbers.find((x) => x.IsDefault);
            let defaultAddress = customer.Addresses.find((x) => x.IsDefault);
            if (customer.Addresses.length === 1) {
              this.getMinutesToDelivery(customer, defaultAddress);
            }
            if (!this.isEditing) customer.SelectedPhoneId = phoneNumber?.Id;
            if (CallerIdNumber) {
              const finditem = customer.Numbers.find((x) => x.Number === CallerIdNumber)?.Id;
              if (finditem) customer.SelectedPhoneId = customer.Numbers.find((x) => x.Number === CallerIdNumber)?.Id;
            }
            this.isEditing = false;
            this.currentCustomer = customer;
            if (loadCostomerInfo) this.setCostomerInfo(CallerIdNumber);
            if (customer.DebitRate < 0) {
              this.debitTitle = this.translate("ClientApp.FrontOffice.Order.CustomerOrder.TotalCredit");
            } else {
              this.debitTitle = this.translate("ClientApp.FrontOffice.Order.CustomerOrder.TotalDebit");
            }
            this.customerDetailsIsLoaded$.next({ type: "Loaded", customerId: customer.Id });
            this.cd.markForCheck();
          },
          (err) => {
            console.log(err);
          }
        );
    }
  }

  private getMinutesToDelivery(customer: CustomerDetailInfoViewModel, defaultAddress: CustomerAddress) {
    customer.SelectedAddressId = defaultAddress?.Id;
    if (defaultAddress?.DefaultBranchId) {
      const zoneBranch = defaultAddress.Zone?.Branches?.find((branch) => branch.BranchId === defaultAddress.DefaultBranchId);
      customer.MinutesToDelivery = zoneBranch?.MinutesToDelivery;
    } else {
      const zoneBranch = defaultAddress.Zone?.Branches?.find((branch) => branch.IsDefault);
      customer.MinutesToDelivery = zoneBranch?.MinutesToDelivery;
    }
    this.order.defaultMinutesToDelivery = customer.MinutesToDelivery;
  }
  //پرکردن اطلاعات مشتری در فاکتور ورفتن به صفحه فاکتور
  setCostomerInfo(CallerIdNumber?: string, customer?: CustomerDetailInfoViewModel) {
    /// For Free Shipping
    if (
      this.order.invoice?.CustomerAddress?.Zone?.MinimumPurchaseForFreeShipping > 0 &&
      this.order.invoice?.CustomerAddress?.Zone?.MinimumPurchaseForFreeShipping < this.order.invoice.Total &&
      this.order.invoice.PayableTotal > 0 &&
      (this.order.invoice.DiscountPrice <= 0 || this.order.invoice.DiscountPrice == this.order.invoice.ShippingCost)
    ) {
      this.order.invoice.Discount = 0;
      this.order.invoice.TotalDiscount = 0;
      this.order.invoice.DiscountPrice = 0;
      this.order.invoice.IsDiscountPercent = false;
      this.order.invoice.IgnoreShippingCost = false;
      this.order.setValue("Discount", 0);
    }
    this.order.invoice.Debit = 0;
    this.order.invoice.Credit = 0;

    this.order.setValue("Debit", 0);
    this.order.freeShippingCostDiscount = null;
    if (customer) {
      this.currentCustomer = customer;
    }
    if (this.currentCustomer?.Addresses.length === 1) {
      const defaultAddress = this.currentCustomer?.Addresses.find((x) => x.IsDefault);
      const isActiveCategory: boolean = this.order.customerInActiveCategory(defaultAddress.Id, this.currentCustomer);
      if (isActiveCategory) {
        this.sts.showDialog(
          `${this.translate("ClientApp.FrontOffice.Order.CustomerOrder.PossibilityOfPlacingOrderSelectedCustomer")}`,
          this.translate("ClientApp.FrontOffice.Order.CustomerOrder.ErrorMessage")
        );
        return;
      }
    }

    if (!this.currentCustomer?.IsActive) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.CustomerOrder.CustomerSelectedBecause")} ${
          this.currentCustomer.DeactivationReason
        } ${this.translate("ClientApp.FrontOffice.Order.CustomerOrder.ItIsDisabled")}`,
        this.translate("ClientApp.FrontOffice.Order.CustomerOrder.ErrorMessage")
      );
      return;
    }

    if (!this.currentCustomer) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.CustomerOrder.CustomerNotSelected")}`,
        this.translate("ClientApp.FrontOffice.Order.CustomerOrder.ErrorMessage")
      );
      return;
    } else if (this.currentCustomer?.Addresses.length === 1) {
      this.setCustomerInfoAfterSelectAddress();
    }
    //با هماهنگی نیما کامنت شد
    if (this.currentCustomer?.IsActive /*&& this.currentCustomer?.Id !== this.order.invoice.Customer?.Id*/) {
      /// For Open FastAcess Always
      if (this.currentCustomer?.Addresses.length > 1 && !this.currentCustomer?.SelectedAddressId) {
        this.dialog
          .open(
            AddressPhoneFormComponent,
            {
              model: JSON.parse(JSON.stringify(this.currentCustomer)),
              apiName: "Customer",
              areaName: this.areaName,
              CallerIdNumber: CallerIdNumber,
              label: this.translate("ClientApp.FrontOffice.Order.CustomerOrder.ChoosingCustomerAddressAndTelephoneNumber"),
            },
            {
              autoFocus: true,
              closeOnClickOutside: false,
            }
          )
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (model) => {
              if (model) {
                const isActiveCategory: boolean = this.order.customerInActiveCategory(model["AddressId"], this.currentCustomer);
                if (isActiveCategory) {
                  this.sts.showDialog(
                    `${this.translate("ClientApp.FrontOffice.Order.CustomerOrder.PossibilityOfPlacingOrderSelectedCustomer")}`,
                    this.translate("ClientApp.FrontOffice.Order.CustomerOrder.ErrorMessage")
                  );
                  return;
                }
                this.setCustomerInfoAfterSelectAddress();
                this.order.invoice.CustomerAddress = this.currentCustomer?.Addresses.find((x) => x.Id === model["AddressId"]);
                this.order.invoice.AddressId = model["AddressId"];
                this.order.invoice.PhoneNumber = this.currentCustomer?.Numbers.find((x) => x.Id === model["PhoneId"]).Number;
                this.order.invoice.MultiPhoneNumber = this.currentCustomer?.Numbers.map((e) => e.Number).join("-");
                this.order.invoice.PhoneId = model["PhoneId"];
                this.order.invoiceChanged = true;
                this.order._opened = false;
                this.order.formGroup.controls["ShippingCost"].setValue(this.order.invoice.ShippingCost);
                const address = this.order.invoice.CustomerAddress;
                this.order.invoice.CustomerAddres = address.Address;
                this.order.freeShippingCostDiscount = null;
                this.setDefaultBranchId();
                this.order.setInvoiceHasFactorAndHasPaymentLink();
                this.setDefaultCosts(address);
                this.getMinutesToDelivery(this.order.invoice.Customer, address);
                this.common.isMobileMode ? this.order.setActivePage(ActivePageEnum.OrderItem) : this.order.setActivePage(ActivePageEnum.Order);
                this.currentCustomer = null;

                this.order.calculate(true);
                this.order.cd.markForCheck();
              }
            },
            (error) => {
              this.sts.showDialog(
                `${this.translate("ClientApp.FrontOffice.Order.CustomerOrder.CustomerPhoneNotSelected")}`,
                this.translate("ClientApp.FrontOffice.Order.CustomerOrder.ErrorMessage")
              );
              this.isEditing = false;
              return;
            }
          );
      } else {
        if (this.currentCustomer?.Addresses.length === 1 && !this.currentCustomer?.SelectedAddressId)
          this.currentCustomer.SelectedAddressId = this.currentCustomer?.Addresses?.find((x) => x.IsDefault).Id;

        if (this.currentCustomer?.Numbers?.some((x) => x.IsDefault) && !this.currentCustomer?.SelectedPhoneId && !this.isEditing)
          this.currentCustomer.SelectedPhoneId = this.currentCustomer?.Numbers?.find((x) => x.IsDefault).Id;
        this.isEditing = false;
        if (this.order.invoice.CustomerId !== this.currentCustomer?.Id || this.currentCustomer.Number === 0) {
          this.order.invoice.Customer.Addresses = this.currentCustomer?.Addresses;
          this.order.invoice.AddressId = this.currentCustomer?.SelectedAddressId;
          this.order.invoice.CustomerAddress = this.currentCustomer?.Addresses?.find((x) => x.Id === this.currentCustomer?.SelectedAddressId);
          this.order.invoice.CustomerAddres = this.order.invoice.CustomerAddress?.Address;
          this.order.invoice.ShippingCost = this.order.invoice.CustomerAddress?.ShippingCost;
          this.order.formGroup.controls["ShippingCost"].setValue(this.order.invoice.ShippingCost);

          this.order.invoice.PhoneId = this.currentCustomer?.SelectedPhoneId;
          this.order.invoice.PhoneNumber = this.currentCustomer?.Numbers.find((x) => x.Id === this.currentCustomer?.SelectedPhoneId)?.Number;
          this.order.invoice.MultiPhoneNumber = this.currentCustomer?.Numbers.map((e) => e.Number).join("-");
          this.order.invoiceChanged = true;
        } else {
          if (this.order.invoice.AddressId !== this.currentCustomer?.SelectedAddressId) {
            this.order.invoice.AddressId = this.currentCustomer?.SelectedAddressId;
            this.order.invoice.CustomerAddress = this.currentCustomer?.Addresses?.find((x) => x.Id === this.currentCustomer?.SelectedAddressId);
            this.order.invoice.CustomerAddres = this.order.invoice.CustomerAddress?.Address;
            this.order.invoice.ShippingCost =
              this.order.invoice.CustomerAddress?.ShippingCost > 0
                ? this.order.invoice.CustomerAddress?.ShippingCost
                : this.order.invoice.ShippingCost;
            this.order.formGroup.controls["ShippingCost"].setValue(this.order.invoice.ShippingCost);

            this.order.invoiceChanged = true;
          }
          if (this.order.invoice.PhoneId !== this.currentCustomer?.SelectedPhoneId) {
            this.order.invoice.PhoneId = this.currentCustomer?.SelectedPhoneId;
            if (this.currentCustomer?.Numbers?.length > 0) {
              this.order.invoice.PhoneNumber = this.currentCustomer?.Numbers?.find((x) => x.Id === this.currentCustomer?.SelectedPhoneId)?.Number;
              this.order.invoice.MultiPhoneNumber = this.currentCustomer?.Numbers.map((e) => e.Number).join("-");
            }
            this.order.invoiceChanged = true;
          }
        }
        this.setDefaultBranchId();
        this.setDefaultCosts(this.order.invoice.Customer?.Addresses[0] ? this.order.invoice.Customer?.Addresses[0] : null);
        this.common.isMobileMode ? this.order.setActivePage(ActivePageEnum.OrderItem) : this.order.setActivePage(ActivePageEnum.Order);
        this.currentCustomer = null;
        this.order.setInvoiceHasFactorAndHasPaymentLink();

        this.order.calculate();
      }
    } else {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.CustomerOrder.TargetCustomerBecause")} "` +
          this.currentCustomer?.DeactivationReason +
          `" ${this.translate("ClientApp.FrontOffice.Order.CustomerOrder.InactiveCannotSelected")}`,
        "پیغام خطا"
      );
    }
  }

  stateChange() {
    this.dialogService
      .open(
        CustomerFormComponent,
        {
          CallerIdNumber: this.CallerIdNumber,
          apiName: "Customer",
          areaName: "RestaurantSale",
          label: this.translate("ClientApp.FrontOffice.Order.CustomerOrder.Customer"),
        },
        {
          closeOnClickOutside: false,
          autoFocus: false,
          closeOnEscape: true,
        }
      )
      .subscribe((ele) => {
        if (ele) {
          this.httpCommonService
            .getItem("Customer/GetCustomerDetails", ele.Id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((data: CustomerDetailInfoViewModel) => {
              this.setCostomerInfo(null, data);
              this.order.detectChanges();
            });
        }
      });
  }

  private setCustomerInfoAfterSelectAddress() {
    this.order.invoice.Customer = JSON.parse(JSON.stringify(this.currentCustomer));
    const customer = this.order.invoice?.Customer;
    this.order.invoice.CustomerId = customer?.Id;
    this.order.invoice.IsDiscountPercent = true;
    this.order.invoice.Discount = customer?.PercentDiscount;
    this.order.invoice.customerDiscountValue = customer.PercentDiscount;
    if (customer?.PercentDiscount) {
      this.order.invoice.IsDiscountPercent = true;
      this.order.invoice.DiscountType = DiscountTypeEnum.Subscription;
    }
    this.order.setValue("Discount", customer?.PercentDiscount);
    this.order.invoice.CustomerDisplayName = customer?.Party?.DisplayName;
    this.order.invoice.Debit =
      this.currentCustomer?.AutomaticDebtor && this.order.currentSaleMethodNature === this.order.SaleMethodNature.Delivery
        ? this.order.invoice.PayableTotal
        : 0;
    if (this.order.invoice.Debit > 0) this.order.formGroup.controls["Debit"].setValue(this.order.invoice.Debit);
    this.order.invoice.Customer.HasCredit = this.currentCustomer?.HasCredit;
    this.order.invoice.CustomerNumber = this.currentCustomer?.Number;
    this.currentCustomer = JSON.parse(JSON.stringify(this.order.invoice.Customer));
  }

  private setDefaultCosts(address: CustomerAddress): void {
    const branchFromZone = address?.Zone.Branches.find((x) => x.BranchId === this.order.invoice.BranchId);
    this.order.invoice.ShippingCost = address?.ShippingCost || branchFromZone?.ShippingCost;
    this.order.invoice.CourierShippingCost = address?.CourierShippingCost || branchFromZone?.CourierShippingCost;
    this.order.setValue("ShippingCost", this.order.invoice.ShippingCost);
    this.order.setValue("CourierShippingCost", this.order.invoice.CourierShippingCost);
    if (this.order.defaultBranch?.Suspend) {
      this.order.setValue("BranchId", null);
      this.order.invoice.BranchId = null;
      this.order.ChangeBranch(null);
    }
  }

  private setDefaultBranchId(): void {
    if (!this.order.isMultiBranch) return;
    if (this.order.itemCategoryListAll?.length) {
      let defaultBranchId = this.order.logInBranch.Id;
      if (!!this.order.isMultiBranch) {
        defaultBranchId = this?.order?.invoice?.CustomerAddress?.DefaultBranchId
          ? this?.order?.invoice?.CustomerAddress?.DefaultBranchId
          : this?.order?.invoice?.CustomerAddress?.Zone?.Branches?.find((f) => f.IsDefault)?.BranchId;
      }
      this.order.defaultBranch = this.order.Branches.find((x) => x.Id === defaultBranchId);
      if (this.order.defaultBranch && !this.order.defaultBranch.IsActive) {
        this.sts.showDialog(
          this.translate("ClientApp.FrontOffice.Order.CustomerOrder.BranchCorrespondingSelectedSubscriberInactive"),
          this.translate("ClientApp.FrontOffice.Order.CustomerOrder.Attention")
        );
        defaultBranchId = null;
      }
      this.order.setValue("BranchId", defaultBranchId);
      this.order.ChangeBranch(defaultBranchId);
    } else {
      setTimeout(() => {
        this.setDefaultBranchId();
      }, 200);
    }
  }
}
